import * as React from "react";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { useStoreFinderContext, Hooks, Util, Components } from "@grandvisionhq/stores-v2";
import { fromStoreToStoreResult } from "../../../../../../../pages/BookAppointment/adapters/v3/pages/BookAppointment/adapters/from-store-to-store-result.js";
import { useAppointmentContext } from "../../../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
const { StoreFinderClickableItem, StoreFinderItem } = Components;
const { useFormattedDistance } = Hooks;
const StoreFinderItemContainer = ({ store, variant, onClick, icon, ...rest }) => {
  const { locale } = useIntl();
  const { setHoveredStore } = useStoreFinderContext();
  const [{ setStore }] = useAppointmentContext();
  const [{ goTo }, { queryParams }] = useRoutingContext();
  const { isMultilingualEnabled, featureConfigs } = useFeatureToggles();
  const {
    appointmentBookingUrlPaddedLength,
    appointmentBookingAlternativeUrl,
    appointmentBookingAlternativeUrlStores
  } = featureConfigs;
  const formattedDistance = useFormattedDistance(store?.distance);
  const onMouseEnterHandler = React.useCallback(() => {
    if (variant === "map-item") {
      return;
    }
    if (!store) {
      return;
    }
    setHoveredStore(fromStoreToStoreResult(store));
  }, [setHoveredStore, store, variant]);
  const onMouseLeaveHandler = React.useCallback(() => {
    if (variant === "map-item") {
      return;
    }
    setHoveredStore(null);
  }, [setHoveredStore, variant]);
  const onClickHandler = React.useCallback(() => {
    if (!store) {
      return;
    }
    onClick?.(store);
    const invalidUrl = "##invalid_url##";
    const alternativeLocation = Util.getBookAppointmentUrl(invalidUrl, {
      paddedLength: appointmentBookingUrlPaddedLength,
      alternativeUrl: appointmentBookingAlternativeUrl && isMultilingualEnabled ? appointmentBookingAlternativeUrl[locale] : appointmentBookingAlternativeUrl,
      alternativeUrlStores: appointmentBookingAlternativeUrlStores
    })(store);
    if (!alternativeLocation.includes(invalidUrl)) {
      window.location.assign(alternativeLocation);
      return;
    }
    setStore(store);
    const { typeId, search, userLocation, linkedAppointmentTypeId } = queryParams;
    const nextStep = typeId ? "when" : "what";
    goTo(nextStep, {
      linkedAppointmentTypeId,
      typeId,
      storeId: `${store.globalStoreId}`,
      search,
      userLocation
    });
  }, [
    onClick,
    setStore,
    store,
    goTo,
    queryParams,
    appointmentBookingUrlPaddedLength,
    isMultilingualEnabled,
    locale,
    appointmentBookingAlternativeUrl,
    appointmentBookingAlternativeUrlStores
  ]);
  if (!store) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    StoreFinderClickableItem,
    {
      ...rest,
      icon,
      variant,
      onClick: onClickHandler,
      onMouseEnter: onMouseEnterHandler,
      onMouseLeave: onMouseLeaveHandler
    },
    /* @__PURE__ */ React.createElement(
      StoreFinderItem,
      {
        view: variant === "map-item" ? "map" : "list",
        store: fromStoreToStoreResult(store),
        showAttributesAs: "tags",
        showEmailAddress: false,
        showPhone: false,
        showOpeningHours: false,
        addressSize: "MINIMAL",
        distance: formattedDistance
      }
    )
  );
};
export {
  StoreFinderItemContainer as default
};
//# sourceMappingURL=StoreFinderItemContainer.js.map
